/**
 * Shared LifeMart/employer access codes. Keep in sync with any marketing
 * collateral or HR handouts. Validation happens server-side; this list is
 * also used client-side for immediate feedback.
 */
export const VALID_LIFEMART_CODES = [
  "LIFEMART2025",
  "LIFEMART-DEMO",
  "LM-PILOT",
  "LM-FULL2025",
] as const;
